import { Component, inject, signal } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ROUTER_TOKENS } from '../../app.routes';
// RxJS
import { catchError, tap, throwError } from 'rxjs';
// Service
import { RegisterService } from './register.service';
import { LoggingService } from '../../core/utils/logging.service';
// Directive
import { NoneSpecialCharDirective } from '../../core/directive/none-special-char.directive';
// PrimeNG
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
// Utility
import { formatChar } from '../../share/utility/format-char';
// Component
import {
  DialogAlertComponent,
  IDialogData,
  PATH_ICON_ALERT_DIALOG,
} from '../../ui/dialog-alert/dialog-alert.component';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

export interface IFormRegister {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword?: string;
}

@Component({
  selector: 'app-register',
  imports: [
    TranslocoModule,
    FormsModule,
    NoneSpecialCharDirective,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    DialogAlertComponent,
    LanguageConfigComponent,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  private router = inject(Router);
  private registerService = inject(RegisterService);
  private readonly loggingService = inject(LoggingService);
  private readonly translocoService = inject(TranslocoService);

  loadingButtonSignal = signal<boolean>(false);
  formRegisterSignal = signal<IFormRegister>({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  validConfirmPassword = signal<boolean>(true);

  // Dialog //
  dialogSignal = signal<IDialogData>({
    image: '',
    title: '',
    description: '',
    delay: 1000,
    visible: false,
  });
  // ------ //

  onChangePassword(event: any, form: FormGroup) {
    // this.loggingService.log('onChangePassword => ', form);
    // FIXME - When need confirm password
    // const password = event.target.value;
    // const confirmPassword = this.formRegisterSignal().confirmPassword;
    // if (form.get('confirmPassword')?.dirty) {
    //   if (password !== confirmPassword) {
    //     this.validConfirmPassword.set(false);
    //   } else {
    //     this.validConfirmPassword.set(true);
    //   }
    // }
  }

  onChangeConfirmPassword(event: any) {
    // this.loggingService.log('event => ', form);
    // FIXME - When need confirm password
    // const password = this.formRegisterSignal().password;
    // const confirmPassword = event.target.value;
    // if (password !== confirmPassword) {
    //   this.validConfirmPassword.set(false);
    // } else {
    //   this.validConfirmPassword.set(true);
    // }
  }

  // protected async onSubmit() {
  onSubmit() {
    this.loggingService.log('sss');
    const { firstName, lastName, email, password } = this.formRegisterSignal();
    const formSend = {
      firstName: formatChar(firstName),
      lastName: formatChar(lastName),
      email,
      // password,
    };
    this.loadingButtonSignal.set(true);
    this.registerService
      .register(formSend)
      .pipe(
        tap(() => this.loggingService.warn('[COMP]-register done')),
        catchError((err) => {
          this.loggingService.error('err =>', err);
          const dataDialog: IDialogData = {
            image: PATH_ICON_ALERT_DIALOG.FAIL,
            title: this.translateWord('register.dialog.registration_fail'),
            description:
              err.error.statusCode === 409
                ? this.translateWord('register.dialog.email_already_exists')
                : this.translateWord('register.dialog.please_try_again'),
            delay: 2000,
            visible: true,
          };
          this.openDialog(dataDialog);
          return throwError(() => err);
        })
      )
      .subscribe(() => {
        const dataDialog: IDialogData = {
          image: PATH_ICON_ALERT_DIALOG.SUCCESS,
          title: this.translateWord('register.dialog.registration_success'),
          description: '',
          delay: 1000,
          visible: true,
        };
        this.openDialog(dataDialog);
      });
    // await this.router.navigate([`/${ROUTER_TOKENS.AUTH_CHECK_EMAIL}`]);
  }

  disableBtn(form: FormGroup): boolean {
    // Create
    return form.valid && this.validConfirmPassword();
  }

  openDialog(data: IDialogData) {
    this.dialogSignal.set(data);
  }

  onCloseDialog() {
    this.dialogSignal.update((res) => ({
      ...res,
      visible: false,
    }));
    if (this.dialogSignal().image.includes('success')) {
      this.router.navigate([`/${ROUTER_TOKENS.AUTH_CHECK_EMAIL}`]);
    }
    this.loadingButtonSignal.set(false);
  }

  translateWord(key: string) {
    return this.translocoService.translate(key);
  }
}
